const isICompositeVariant = (variant) => {
    return Object.values(variant.components).every((component) => {
        if (component === null) {
            return true;
        }
        if ('attributes' in component.variant) {
            return true;
        }
        return false;
    });
};

const AttributeTypes = {
    Integer: 'integer',
    Boolean: 'boolean',
    Decimal: 'decimal',
    Text: 'text',
    RAL: 'RAL',
};
const AttributeBehaviourTypes = {
    Configurable: 'configurable',
    UserInput: 'user_input',
    Hidden: 'hidden',
};

function isConditionActive(condition, product) {
    const ruleJS = new Function('product', condition.fn);
    return Boolean(ruleJS(product));
}

const CUSTOM_ATTRIBUTE_VALUE = '_custom_';
const NA_ATTRIBUTE_VALUE = '_na_';
const SystemVariantTypes = {
    default: 'default',
    nullish: 'nullish',
};
const VariantProperties = {
    compoundId: '_id',
    available: '_available',
    variantId: '_variantId',
    productId: '_productId',
    productKey: '_productKey',
    model3dId: '_model3dId',
    type: '_type',
    meta: '_meta',
    viewModel3dKey: '_viewModel3dKey',
};

const colors = {
    '1000': '#BEBD7F',
    '1001': '#C2B078',
    '1002': '#C6A664',
    '1003': '#E5BE01',
    '1004': '#CDA434',
    '1005': '#A98307',
    '1006': '#E4A010',
    '1007': '#DC9D00',
    '1011': '#8A6642',
    '1012': '#C7B446',
    '1013': '#EAE6CA',
    '1014': '#E1CC4F',
    '1015': '#E6D690',
    '1016': '#EDFF21',
    '1017': '#F5D033',
    '1018': '#F8F32B',
    '1019': '#9E9764',
    '1020': '#999950',
    '1021': '#F3DA0B',
    '1023': '#FAD201',
    '1024': '#AEA04B',
    '1026': '#FFFF00',
    '1027': '#9D9101',
    '1028': '#F4A900',
    '1032': '#D6AE01',
    '1033': '#F3A505',
    '1034': '#EFA94A',
    '1035': '#6A5D4D',
    '1036': '#705335',
    '1037': '#F39F18',
    '2000': '#ED760E',
    '2001': '#C93C20',
    '2002': '#CB2821',
    '2003': '#FF7514',
    '2004': '#F44611',
    '2005': '#FF2301',
    '2007': '#FFA420',
    '2008': '#F75E25',
    '2009': '#F54021',
    '2010': '#D84B20',
    '2011': '#EC7C26',
    '2012': '#E55137',
    '2013': '#C35831',
    '3000': '#AF2B1E',
    '3001': '#A52019',
    '3002': '#A2231D',
    '3003': '#9B111E',
    '3004': '#75151E',
    '3005': '#5E2129',
    '3007': '#412227',
    '3009': '#642424',
    '3011': '#781F19',
    '3012': '#C1876B',
    '3013': '#A12312',
    '3014': '#D36E70',
    '3015': '#EA899A',
    '3016': '#B32821',
    '3017': '#E63244',
    '3018': '#D53032',
    '3020': '#CC0605',
    '3022': '#D95030',
    '3024': '#F80000',
    '3026': '#FE0000',
    '3027': '#C51D34',
    '3028': '#CB3234',
    '3031': '#B32428',
    '3032': '#721422',
    '3033': '#B44C43',
    '4001': '#6D3F5B',
    '4002': '#922B3E',
    '4003': '#DE4C8A',
    '4004': '#641C34',
    '4005': '#6C4675',
    '4006': '#A03472',
    '4007': '#4A192C',
    '4008': '#924E7D',
    '4009': '#A18594',
    '4010': '#CF3476',
    '4011': '#8673A1',
    '4012': '#6C6874',
    '5000': '#354D73',
    '5001': '#1F3438',
    '5002': '#20214F',
    '5003': '#1D1E33',
    '5004': '#18171C',
    '5005': '#1E2460',
    '5007': '#3E5F8A',
    '5008': '#26252D',
    '5009': '#025669',
    '5010': '#0E294B',
    '5011': '#231A24',
    '5012': '#3B83BD',
    '5013': '#1E213D',
    '5014': '#606E8C',
    '5015': '#2271B3',
    '5017': '#063971',
    '5018': '#3F888F',
    '5019': '#1B5583',
    '5020': '#1D334A',
    '5021': '#256D7B',
    '5022': '#252850',
    '5023': '#49678D',
    '5024': '#5D9B9B',
    '5025': '#2A6478',
    '5026': '#102C54',
    '6000': '#316650',
    '6001': '#287233',
    '6002': '#2D572C',
    '6003': '#424632',
    '6004': '#1F3A3D',
    '6005': '#2F4538',
    '6006': '#3E3B32',
    '6007': '#343B29',
    '6008': '#39352A',
    '6009': '#31372B',
    '6010': '#35682D',
    '6011': '#587246',
    '6012': '#343E40',
    '6013': '#6C7156',
    '6014': '#47402E',
    '6015': '#3B3C36',
    '6016': '#1E5945',
    '6017': '#4C9141',
    '6018': '#57A639',
    '6019': '#BDECB6',
    '6020': '#2E3A23',
    '6021': '#89AC76',
    '6022': '#25221B',
    '6024': '#308446',
    '6025': '#3D642D',
    '6026': '#015D52',
    '6027': '#84C3BE',
    '6028': '#2C5545',
    '6029': '#20603D',
    '6032': '#317F43',
    '6033': '#497E76',
    '6034': '#7FB5B5',
    '6035': '#1C542D',
    '6036': '#193737',
    '6037': '#008F39',
    '6038': '#00BB2D',
    '7000': '#78858B',
    '7001': '#8A9597',
    '7002': '#7E7B52',
    '7003': '#6C7059',
    '7004': '#969992',
    '7005': '#646B63',
    '7006': '#6D6552',
    '7008': '#6A5F31',
    '7009': '#4D5645',
    '7010': '#4C514A',
    '7011': '#434B4D',
    '7012': '#4E5754',
    '7013': '#464531',
    '7015': '#434750',
    '7016': '#293133',
    '7021': '#23282B',
    '7022': '#332F2C',
    '7023': '#686C5E',
    '7024': '#474A51',
    '7026': '#2F353B',
    '7030': '#8B8C7A',
    '7031': '#474B4E',
    '7032': '#B8B799',
    '7033': '#7D8471',
    '7034': '#8F8B66',
    '7035': '#D7D7D7',
    '7036': '#7F7679',
    '7037': '#7D7F7D',
    '7038': '#B5B8B1',
    '7039': '#6C6960',
    '7040': '#9DA1AA',
    '7042': '#8D948D',
    '7043': '#4E5452',
    '7044': '#CAC4B0',
    '7045': '#909090',
    '7046': '#82898F',
    '7047': '#D0D0D0',
    '7048': '#898176',
    '8000': '#826C34',
    '8001': '#955F20',
    '8002': '#6C3B2A',
    '8003': '#734222',
    '8004': '#8E402A',
    '8007': '#59351F',
    '8008': '#6F4F28',
    '8011': '#5B3A29',
    '8012': '#592321',
    '8014': '#382C1E',
    '8015': '#633A34',
    '8016': '#4C2F27',
    '8017': '#45322E',
    '8019': '#403A3A',
    '8022': '#212121',
    '8023': '#A65E2E',
    '8024': '#79553D',
    '8025': '#755C48',
    '8028': '#4E3B31',
    '8029': '#763C28',
    '9001': '#FDF4E3',
    '9002': '#E7EBDA',
    '9003': '#F4F4F4',
    '9004': '#282828',
    '9005': '#0A0A0A',
    '9006': '#A5A5A5',
    '9007': '#8F8F8F',
    '9010': '#FFFFFF',
    '9011': '#1C1C1C',
    '9016': '#F6F6F6',
    '9017': '#1E1E1E',
    '9018': '#D7D7D7',
    '9022': '#9C9C9C',
    '9023': '#828282',
};
const RALCodes = Object.keys(colors).map(Number);
const RAL = {
    codes: RALCodes,
    custom: CUSTOM_ATTRIBUTE_VALUE,
};
function isValidRAL(value) {
    return value === RAL.custom || RAL.codes.some((code) => `RAL ${code}` === value);
}
function ralCodeToHex(code) {
    const color = colors[code];
    if (!color) {
        throw new Error(`Cannot find RAL color`);
    }
    return color;
}
function ralToHex(value) {
    const match = /\d+/.exec(value);
    if (!match) {
        throw new Error(`Invalid format ${value}`);
    }
    const code = match[0];
    return ralCodeToHex(+code);
}

function isNullishAttributeValue(value) {
    return value == null;
}
function hasAttributeValue(attributeValue) {
    return 'value' in attributeValue;
}
function compareAttributeValue(a, b) {
    if (hasAttributeValue(a) && hasAttributeValue(b)) {
        return a.value == b.value;
    }
    return false;
}
function attributeValueCase(attributeValue) {
    if (hasAttributeValue(attributeValue)) {
        if (attributeValue.custom) {
            return {
                type: 'customValue',
                custom: attributeValue.custom,
                value: attributeValue.value,
            };
        }
        else {
            return {
                type: 'value',
                value: attributeValue.value,
            };
        }
    }
    else {
        if (attributeValue.custom) {
            return {
                type: 'emptyCustom',
                custom: attributeValue.custom,
            };
        }
        throw new Error(`Invalid attribute value`);
    }
}
function createAttributeValue(value) {
    return {
        value,
    };
}
function createCustomAttributeValue(value) {
    return {
        custom: true,
        value,
    };
}
function createAttributeProperty(value) {
    return {
        value: value,
    };
}
function getAttributeValue(attributeValue) {
    if (!attributeValue) {
        throw new Error(`Attribute value is undefined`);
    }
    if (hasAttributeValue(attributeValue)) {
        return attributeValue.value;
    }
    throw new Error(`Invalid attribute value`);
}
function extractAttributeValue(productVariant, key) {
    return getAttributeValue(productVariant[key]);
}
function extractPropertyValue(productVariant, key) {
    const value = productVariant[key];
    if (hasAttributeValue(value)) {
        return value.value;
    }
    throw new Error(`Invalid attribute value`);
}
const getStringSA = (productVariant, attributeKey) => {
    const value = extractAttributeValue(productVariant, attributeKey);
    if (typeof value !== 'string') {
        throw new Error(`System attribute '${attributeKey}' has invalid value ${value}`);
    }
    return value;
};
function isSystemAttribute(attributeKey) {
    return Object.values(VariantProperties)
        .map((it) => String(it))
        .includes(attributeKey);
}
function isSystemAttributeKey(attributeKey) {
    return attributeKey in VariantProperties;
}
const isISystemAttributeValue = (value, attributeKey) => {
    return isSystemAttribute(attributeKey) && 'value' in value;
};
class ConfiguratorPV {
    constructor(productVariant) {
        this.productVariant = productVariant;
    }
    static fromRaw(productVariant, config, customValues) {
        const attributes = {};
        for (const [key, value] of Object.entries(productVariant)) {
            if (value === CUSTOM_ATTRIBUTE_VALUE && customValues) {
                attributes[key] = createCustomAttributeValue(customValues[key]);
            }
            else {
                attributes[key] = createAttributeValue(value);
            }
        }
        const variant = Object.assign(Object.assign({}, attributes), { [VariantProperties.type]: createAttributeProperty(SystemVariantTypes.default), [VariantProperties.available]: createAttributeProperty(config.available), [VariantProperties.productId]: createAttributeProperty(config.productId), [VariantProperties.productKey]: createAttributeProperty(config.productKey), [VariantProperties.variantId]: createAttributeProperty(config.variantId), [VariantProperties.compoundId]: createAttributeProperty(config.compoundId), [VariantProperties.meta]: createAttributeProperty(config.meta), [VariantProperties.model3dId]: createAttributeProperty(config.model3dId) });
        return new ConfiguratorPV(variant);
    }
    static fromEmpty(config) {
        const variant = {
            [VariantProperties.compoundId]: createAttributeProperty(config.compoundId),
            [VariantProperties.type]: createAttributeProperty(SystemVariantTypes.nullish),
            [VariantProperties.available]: createAttributeProperty(false),
        };
        return new ConfiguratorPV(variant);
    }
    get raw() {
        return this.productVariant;
    }
    get flat() {
        const attrs = this.omitProperties();
        const result = {};
        for (const [key, value] of Object.entries(attrs)) {
            result[key] = getAttributeValue(value);
        }
        return result;
    }
    setAvailable(productVariant, value) {
        productVariant[VariantProperties.available] = createAttributeValue(value);
    }
    get compoundId() {
        return getStringSA(this.productVariant, VariantProperties.compoundId);
    }
    get productId() {
        if (this.isNullish) {
            return '';
        }
        else {
            return getStringSA(this.productVariant, VariantProperties.productId);
        }
    }
    get variantId() {
        return getStringSA(this.productVariant, VariantProperties.variantId);
    }
    get isNullish() {
        return getStringSA(this.productVariant, VariantProperties.type) === SystemVariantTypes.nullish;
    }
    isAvailable() {
        return getAttributeValue(this.productVariant[VariantProperties.available]) === true;
    }
    get meta() {
        return extractPropertyValue(this.productVariant, VariantProperties.meta);
    }
    get productKey() {
        return extractPropertyValue(this.productVariant, VariantProperties.productKey);
    }
    omitProductAttributes() {
        const result = {};
        for (const [key, value] of Object.entries(this.productVariant)) {
            if (isISystemAttributeValue(value, key)) {
                result[key] = value;
            }
        }
        return result;
    }
    omitProperties() {
        const result = {};
        for (const [key, value] of Object.entries(this.productVariant)) {
            if (!isSystemAttribute(key)) {
                result[key] = value;
            }
        }
        return result;
    }
}

const isCfgProductVariant = (record) => {
    return Object.keys(record).some((key) => isSystemAttribute(key));
};

function isAncestorOf(ancestor, node) {
    let current = node;
    while (current.parent) {
        if (current.parent.partKey === ancestor.partKey) {
            return true;
        }
        current = current.parent;
    }
    return false;
}
function traverseTree(part, fn) {
    const traverseChildren = fn(part);
    if (traverseChildren === false) {
        return;
    }
    for (const child of part.children) {
        traverseTree(child, fn);
    }
}
function traverseForest(parts, fn) {
    for (const part of parts) {
        traverseTree(part, fn);
    }
}
function createNodes(data, filterFn = () => true) {
    const roots = data.filter((it) => !it.parentPartKey);
    const result = [];
    for (const root of roots) {
        addChildren(root, data, result, filterFn);
    }
    return result;
}
function findPartNodes(parts, partKeys) {
    const foundNodes = partKeys.map(() => null);
    traverseForest(parts, (part) => {
        if (partKeys.includes(part.partKey)) {
            const idx = partKeys.indexOf(part.partKey);
            foundNodes[idx] = part;
        }
    });
    return foundNodes;
}
function addChildren(dto, source, result, filterFn = () => true) {
    if (!filterFn(dto)) {
        return;
    }
    const parentNode = Object.assign(Object.assign({}, dto), { parent: null, children: [] });
    result.push(parentNode);
    const children = source.filter((it) => it.parentPartKey === dto.partKey);
    for (const child of children) {
        addChildren(child, source, parentNode.children, filterFn);
    }
    for (const child of parentNode.children) {
        child.parent = parentNode;
    }
}

function canMovePart(parts, sourceKey, targetKey) {
    if (sourceKey === targetKey) {
        return false;
    }
    if (targetKey === '') {
        const [sourceNode] = findPartNodes(parts, [sourceKey]);
        return !!(sourceNode === null || sourceNode === void 0 ? void 0 : sourceNode.parent);
    }
    const [sourceNode, targetNode] = findPartNodes(parts, [sourceKey, targetKey]);
    if (sourceNode && targetNode) {
        return !isAncestorOf(sourceNode, targetNode);
    }
    return false;
}
function computePartsAmount(parts, availableComponentsKeys) {
    const components = new Map();
    const componentsKeysSet = new Set(availableComponentsKeys);
    for (const componentKey of availableComponentsKeys) {
        components.set(componentKey, { amount: 0 });
    }
    const nodes = createNodes(parts.map((it) => ({
        parentPartKey: it.parentPartKey,
        partKey: it.partKey,
        component: {
            key: it.componentKey,
        },
    })));
    traverseForest(nodes, (node) => {
        const componentKey = node.component.key;
        if (componentsKeysSet.has(componentKey)) {
            const cmp = components.get(componentKey);
            if (!cmp) {
                throw new Error(`Cannot find component "${componentKey}"`);
            }
            cmp.amount++;
        }
        else {
            return false;
        }
    });
    return (componentKey) => {
        var _a, _b;
        return (_b = (_a = components.get(componentKey)) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : 0;
    };
}
function getValidParentParts(parts, sourceKey) {
    const validParts = [];
    const [sourceNode] = findPartNodes(parts, [sourceKey]);
    if (!sourceNode) {
        throw new Error(`Cannot find part ${sourceKey}`);
    }
    traverseForest(parts, (part) => {
        if (sourceNode.parentPartKey === part.partKey ||
            (part.partKey !== sourceKey && canMovePart(parts, sourceKey, part.partKey))) {
            validParts.push(part);
        }
    });
    return validParts;
}
function getRuleValidParentParts(parts, sourceKey) {
    const validParts = [];
    traverseForest(parts, (part) => {
        if (part.partKey !== sourceKey) {
            validParts.push(part);
        }
    });
    return validParts;
}

const defaultPosition = { x: 0, y: 0, z: 0 };
const defaultRotation = { x: 0, y: 0, z: 0 };
const defaultJP = {
    rotation: defaultRotation,
    position: defaultPosition,
};
function equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y && p1.z === p2.z;
}

const defaultRootPartLayout = {
    type: 'rootPartLayout',
    modelsTransforms: {},
};
const defaultChildPartLayout = {
    type: 'childPartLayout',
    mainJointPointKey: '',
    parentJointPointKey: '',
};
const defaultTransform = {
    translation: defaultPosition,
    rotation: defaultPosition,
};

class PartsRegistry {
    constructor() {
        this.parts = [];
        this.middlewares = [];
    }
    clear() {
        this.parts = [];
    }
    addParts(parts) {
        parts.forEach((part) => this.addPart(part));
    }
    addPart(part) {
        if (this.parts.find((it) => it.partKey === part.partKey)) {
            throw new Error(`Part key already exists`);
        }
        this.parts.push(part);
    }
    addMiddleware(middleware) {
        this.middlewares.push(middleware);
    }
    getParts(product) {
        let parts = this.parts.map((part) => {
            let result = part;
            for (const rule of part.rules) {
                if (rule.type === 'layoutRule' && isConditionActive(rule.condition, product)) {
                    result = Object.assign(Object.assign({}, result), { layout: rule.layout, parentPartKey: rule.parentPartKey });
                }
            }
            return result;
        });
        parts = this.filterUnavailableParts(parts, product);
        for (const middleware of this.middlewares) {
            parts = middleware(parts);
        }
        return parts;
    }
    filterUnavailableParts(parts, product) {
        const availableComponents = new Set();
        for (const [componentKey, componentVariant] of Object.entries(product)) {
            if (componentVariant && this.isComponentAvailable(componentVariant)) {
                availableComponents.add(componentKey);
            }
        }
        const nodes = createNodes(parts.map((part) => ({
            partKey: part.partKey,
            parentPartKey: part.parentPartKey || '',
        })));
        const partsToRemove = new Set();
        for (const part of parts) {
            if (!availableComponents.has(part.componentKey)) {
                const [partNode] = findPartNodes(nodes, [part.partKey]);
                if (partNode) {
                    traverseForest([partNode], (node) => {
                        partsToRemove.add(node.partKey);
                    });
                }
            }
        }
        return parts.filter((part) => !partsToRemove.has(part.partKey));
    }
    isComponentAvailable(componentVariant) {
        const available = componentVariant._available;
        return typeof available === 'object' && available !== null && 'value' in available && available.value === true;
    }
}

var util;
(function (util) {
    util.assertEqual = (val) => val;
    function assertIs(_arg) { }
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items) => {
        const obj = {};
        for (const item of items) {
            obj[item] = item;
        }
        return obj;
    };
    util.getValidEnumValues = (obj) => {
        const validKeys = util.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys) {
            filtered[k] = obj[k];
        }
        return util.objectValues(filtered);
    };
    util.objectValues = (obj) => {
        return util.objectKeys(obj).map(function (e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
        ? (obj) => Object.keys(obj) // eslint-disable-line ban/ban
        : (object) => {
            const keys = [];
            for (const key in object) {
                if (Object.prototype.hasOwnProperty.call(object, key)) {
                    keys.push(key);
                }
            }
            return keys;
        };
    util.find = (arr, checker) => {
        for (const item of arr) {
            if (checker(item))
                return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function"
        ? (val) => Number.isInteger(val) // eslint-disable-line ban/ban
        : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array
            .map((val) => (typeof val === "string" ? `'${val}'` : val))
            .join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value) => {
        if (typeof value === "bigint") {
            return value.toString();
        }
        return value;
    };
})(util || (util = {}));
var objectUtil;
(function (objectUtil) {
    objectUtil.mergeShapes = (first, second) => {
        return {
            ...first,
            ...second, // second overwrites first
        };
    };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set",
]);
const getParsedType = (data) => {
    const t = typeof data;
    switch (t) {
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) {
                return ZodParsedType.array;
            }
            if (data === null) {
                return ZodParsedType.null;
            }
            if (data.then &&
                typeof data.then === "function" &&
                data.catch &&
                typeof data.catch === "function") {
                return ZodParsedType.promise;
            }
            if (typeof Map !== "undefined" && data instanceof Map) {
                return ZodParsedType.map;
            }
            if (typeof Set !== "undefined" && data instanceof Set) {
                return ZodParsedType.set;
            }
            if (typeof Date !== "undefined" && data instanceof Date) {
                return ZodParsedType.date;
            }
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};

const ZodIssueCode = util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite",
]);
const quotelessJson = (obj) => {
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
    constructor(issues) {
        super();
        this.issues = [];
        this.addIssue = (sub) => {
            this.issues = [...this.issues, sub];
        };
        this.addIssues = (subs = []) => {
            this.issues = [...this.issues, ...subs];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) {
            // eslint-disable-next-line ban/ban
            Object.setPrototypeOf(this, actualProto);
        }
        else {
            this.__proto__ = actualProto;
        }
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper ||
            function (issue) {
                return issue.message;
            };
        const fieldErrors = { _errors: [] };
        const processError = (error) => {
            for (const issue of error.issues) {
                if (issue.code === "invalid_union") {
                    issue.unionErrors.map(processError);
                }
                else if (issue.code === "invalid_return_type") {
                    processError(issue.returnTypeError);
                }
                else if (issue.code === "invalid_arguments") {
                    processError(issue.argumentsError);
                }
                else if (issue.path.length === 0) {
                    fieldErrors._errors.push(mapper(issue));
                }
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while (i < issue.path.length) {
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) {
                            curr[el] = curr[el] || { _errors: [] };
                            // if (typeof el === "string") {
                            //   curr[el] = curr[el] || { _errors: [] };
                            // } else if (typeof el === "number") {
                            //   const errorArray: any = [];
                            //   errorArray._errors = [];
                            //   curr[el] = curr[el] || errorArray;
                            // }
                        }
                        else {
                            curr[el] = curr[el] || { _errors: [] };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue) => issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues) {
            if (sub.path.length > 0) {
                fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                fieldErrors[sub.path[0]].push(mapper(sub));
            }
            else {
                formErrors.push(mapper(sub));
            }
        }
        return { formErrors, fieldErrors };
    }
    get formErrors() {
        return this.flatten();
    }
}
ZodError.create = (issues) => {
    const error = new ZodError(issues);
    return error;
};

const errorMap = (issue, _ctx) => {
    let message;
    switch (issue.code) {
        case ZodIssueCode.invalid_type:
            if (issue.received === ZodParsedType.undefined) {
                message = "Required";
            }
            else {
                message = `Expected ${issue.expected}, received ${issue.received}`;
            }
            break;
        case ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
            break;
        case ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
            break;
        case ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
            break;
        case ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") {
                        message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                    }
                }
                else if ("startsWith" in issue.validation) {
                    message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                }
                else if ("endsWith" in issue.validation) {
                    message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                }
                else {
                    util.assertNever(issue.validation);
                }
            }
            else if (issue.validation !== "regex") {
                message = `Invalid ${issue.validation}`;
            }
            else {
                message = "Invalid";
            }
            break;
        case ZodIssueCode.too_small:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${issue.minimum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${new Date(Number(issue.minimum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.too_big:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint")
                message = `BigInt must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `smaller than or equal to`
                        : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util.assertNever(issue);
    }
    return { message };
};

let overrideErrorMap = errorMap;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

const makeIssue = (params) => {
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [...path, ...(issueData.path || [])];
    const fullIssue = {
        ...issueData,
        path: fullPath,
    };
    let errorMessage = "";
    const maps = errorMaps
        .filter((m) => !!m)
        .slice()
        .reverse();
    for (const map of maps) {
        errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
    }
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage,
    };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            getErrorMap(),
            errorMap, // then global default map
        ].filter((x) => !!x),
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor() {
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid")
            this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted")
            this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results) {
            if (s.status === "aborted")
                return INVALID;
            if (s.status === "dirty")
                status.dirty();
            arrayValue.push(s.value);
        }
        return { status: status.value, value: arrayValue };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs) {
            syncPairs.push({
                key: await pair.key,
                value: await pair.value,
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs) {
            const { key, value } = pair;
            if (key.status === "aborted")
                return INVALID;
            if (value.status === "aborted")
                return INVALID;
            if (key.status === "dirty")
                status.dirty();
            if (value.status === "dirty")
                status.dirty();
            if (key.value !== "__proto__" &&
                (typeof value.value !== "undefined" || pair.alwaysSet)) {
                finalObject[key.value] = value.value;
            }
        }
        return { status: status.value, value: finalObject };
    }
}
const INVALID = Object.freeze({
    status: "aborted",
});
const DIRTY = (value) => ({ status: "dirty", value });
const OK = (value) => ({ status: "valid", value });
const isAborted = (x) => x.status === "aborted";
const isDirty = (x) => x.status === "dirty";
const isValid = (x) => x.status === "valid";
const isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;

var errorUtil;
(function (errorUtil) {
    errorUtil.errToObj = (message) => typeof message === "string" ? { message } : message || {};
    errorUtil.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));

class ParseInputLazyPath {
    constructor(parent, value, path, key) {
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) {
                this._cachedPath.push(...this._path, ...this._key);
            }
            else {
                this._cachedPath.push(...this._path, this._key);
            }
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result) => {
    if (isValid(result)) {
        return { success: true, data: result.value };
    }
    else {
        if (!ctx.common.issues.length) {
            throw new Error("Validation failed but no issues detected.");
        }
        return {
            success: false,
            get error() {
                if (this._error)
                    return this._error;
                const error = new ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            },
        };
    }
};
function processCreateParams(params) {
    if (!params)
        return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) {
        throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    }
    if (errorMap)
        return { errorMap: errorMap, description };
    const customMap = (iss, ctx) => {
        if (iss.code !== "invalid_type")
            return { message: ctx.defaultError };
        if (typeof ctx.data === "undefined") {
            return { message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError };
        }
        return { message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError };
    };
    return { errorMap: customMap, description };
}
class ZodType {
    constructor(def) {
        /** Alias of safeParseAsync */
        this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return getParsedType(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return (ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: getParsedType(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent,
        });
    }
    _processInputParams(input) {
        return {
            status: new ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: getParsedType(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent,
            },
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if (isAsync(result)) {
            throw new Error("Synchronous parse encountered promise.");
        }
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const result = this._parseSync({ data, path: ctx.path, parent: ctx });
        return handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
        const result = await (isAsync(maybeAsyncResult)
            ? maybeAsyncResult
            : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val) => {
            if (typeof message === "string" || typeof message === "undefined") {
                return { message };
            }
            else if (typeof message === "function") {
                return message(val);
            }
            else {
                return message;
            }
        };
        return this._refinement((val, ctx) => {
            const result = check(val);
            const setError = () => ctx.addIssue({
                code: ZodIssueCode.custom,
                ...getIssueProperties(val),
            });
            if (typeof Promise !== "undefined" && result instanceof Promise) {
                return result.then((data) => {
                    if (!data) {
                        setError();
                        return false;
                    }
                    else {
                        return true;
                    }
                });
            }
            if (!result) {
                setError();
                return false;
            }
            else {
                return true;
            }
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx) => {
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function"
                    ? refinementData(val, ctx)
                    : refinementData);
                return false;
            }
            else {
                return true;
            }
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "refinement", refinement },
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this, this._def);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([this, option], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "transform", transform },
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : () => def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault,
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def),
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : () => def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch,
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description,
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[a-z][a-z0-9]*$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
const ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const datetimeRegex = (args) => {
    if (args.precision) {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
        }
    }
    else if (args.precision === 0) {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
        }
    }
    else {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
        }
    }
};
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
        return true;
    }
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
        return true;
    }
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = String(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.string,
                received: ctx.parsedType,
            }
            //
            );
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_big,
                            maximum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    else if (tooSmall) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_small,
                            minimum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    status.dirty();
                }
            }
            else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "email",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "emoji") {
                if (!emojiRegex) {
                    emojiRegex = new RegExp(_emojiRegex, "u");
                }
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "emoji",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "uuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid2",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ulid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "url") {
                try {
                    new URL(input.data);
                }
                catch (_a) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "url",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "regex",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "trim") {
                input.data = input.data.trim();
            }
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { includes: check.value, position: check.position },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "toLowerCase") {
                input.data = input.data.toLowerCase();
            }
            else if (check.kind === "toUpperCase") {
                input.data = input.data.toUpperCase();
            }
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { startsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { endsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ip",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    _regex(regex, validation, message) {
        return this.refinement((data) => regex.test(data), {
            validation,
            code: ZodIssueCode.invalid_string,
            ...errorUtil.errToObj(message),
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    email(message) {
        return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
    }
    url(message) {
        return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
    }
    emoji(message) {
        return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
    }
    uuid(message) {
        return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
    }
    cuid(message) {
        return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
    }
    cuid2(message) {
        return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
    }
    ulid(message) {
        return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
    }
    ip(options) {
        return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") {
            return this._addCheck({
                kind: "datetime",
                precision: null,
                offset: false,
                message: options,
            });
        }
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil.errToObj(message),
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil.errToObj(message),
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil.errToObj(message),
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...errorUtil.errToObj(message),
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */
    nonempty(message) {
        return this.min(1, errorUtil.errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "trim" }],
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toLowerCase" }],
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toUpperCase" }],
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch) => ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch) => ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch) => ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch) => ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch) => ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch) => ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch) => ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodString.create = (params) => {
    var _a;
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return (valInt % stepInt) / Math.pow(10, decCount);
}
class ZodNumber extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = Number(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.number,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "int") {
                if (!util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_finite,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil.toString(message),
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil.toString(message),
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: errorUtil.toString(message),
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: errorUtil.toString(message),
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch) => ch.kind === "int" ||
            (ch.kind === "multipleOf" && util.isInteger(ch.value)));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "finite" ||
                ch.kind === "int" ||
                ch.kind === "multipleOf") {
                return true;
            }
            else if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
            else if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
ZodNumber.create = (params) => {
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodBigInt extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = BigInt(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.bigint) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.bigint,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodBigInt.create = (params) => {
    var _a;
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = Boolean(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.boolean,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodBoolean.create = (params) => {
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = new Date(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.date,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_date,
            });
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime()),
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
ZodDate.create = (params) => {
    return new ZodDate({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params),
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.symbol,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodSymbol.create = (params) => {
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params),
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.undefined,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodUndefined.create = (params) => {
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params),
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.null,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodNull.create = (params) => {
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params),
    });
};
class ZodAny extends ZodType {
    constructor() {
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodAny.create = (params) => {
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params),
    });
};
class ZodUnknown extends ZodType {
    constructor() {
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodUnknown.create = (params) => {
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params),
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.never,
            received: ctx.parsedType,
        });
        return INVALID;
    }
}
ZodNever.create = (params) => {
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params),
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.void,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodVoid.create = (params) => {
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params),
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                addIssueToContext(ctx, {
                    code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
                    minimum: (tooSmall ? def.exactLength.value : undefined),
                    maximum: (tooBig ? def.exactLength.value : undefined),
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message,
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message,
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message,
                });
                status.dirty();
            }
        }
        if (ctx.common.async) {
            return Promise.all([...ctx.data].map((item, i) => {
                return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
            })).then((result) => {
                return ParseStatus.mergeArray(status, result);
            });
        }
        const result = [...ctx.data].map((item, i) => {
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: { value: minLength, message: errorUtil.toString(message) },
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: { value: maxLength, message: errorUtil.toString(message) },
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: { value: len, message: errorUtil.toString(message) },
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodArray.create = (schema, params) => {
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params),
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for (const key in schema.shape) {
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: () => newShape,
        });
    }
    else if (schema instanceof ZodArray) {
        return new ZodArray({
            ...schema._def,
            type: deepPartialify(schema.element),
        });
    }
    else if (schema instanceof ZodOptional) {
        return ZodOptional.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodNullable) {
        return ZodNullable.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodTuple) {
        return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
    }
    else {
        return schema;
    }
}
class ZodObject extends ZodType {
    constructor() {
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */
        this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */
        this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null)
            return this._cached;
        const shape = this._def.shape();
        const keys = util.objectKeys(shape);
        return (this._cached = { shape, keys });
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever &&
            this._def.unknownKeys === "strip")) {
            for (const key in ctx.data) {
                if (!shapeKeys.includes(key)) {
                    extraKeys.push(key);
                }
            }
        }
        const pairs = [];
        for (const key of shapeKeys) {
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: { status: "valid", value: key },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data,
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") {
                for (const key of extraKeys) {
                    pairs.push({
                        key: { status: "valid", value: key },
                        value: { status: "valid", value: ctx.data[key] },
                    });
                }
            }
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.unrecognized_keys,
                        keys: extraKeys,
                    });
                    status.dirty();
                }
            }
            else if (unknownKeys === "strip") ;
            else {
                throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
            }
        }
        else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys) {
                const value = ctx.data[key];
                pairs.push({
                    key: { status: "valid", value: key },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data,
                });
            }
        }
        if (ctx.common.async) {
            return Promise.resolve()
                .then(async () => {
                const syncPairs = [];
                for (const pair of pairs) {
                    const key = await pair.key;
                    syncPairs.push({
                        key,
                        value: await pair.value,
                        alwaysSet: pair.alwaysSet,
                    });
                }
                return syncPairs;
            })
                .then((syncPairs) => {
                return ParseStatus.mergeObjectSync(status, syncPairs);
            });
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...(message !== undefined
                ? {
                    errorMap: (issue, ctx) => {
                        var _a, _b, _c, _d;
                        const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys")
                            return {
                                message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError,
                            };
                        return {
                            message: defaultError,
                        };
                    },
                }
                : {}),
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip",
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough",
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: () => ({
                ...this._def.shape(),
                ...augmentation,
            }),
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: () => ({
                ...this._def.shape(),
                ...merging._def.shape(),
            }),
            typeName: ZodFirstPartyTypeKind.ZodObject,
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({ [key]: schema });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index,
        });
    }
    pick(mask) {
        const shape = {};
        util.objectKeys(mask).forEach((key) => {
            if (mask[key] && this.shape[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    omit(mask) {
        const shape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (!mask[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    /**
     * @deprecated
     */
    deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) {
                newShape[key] = fieldSchema;
            }
            else {
                newShape[key] = fieldSchema.optional();
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    required(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (mask && !mask[key]) {
                newShape[key] = this.shape[key];
            }
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while (newField instanceof ZodOptional) {
                    newField = newField._def.innerType;
                }
                newShape[key] = newField;
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    keyof() {
        return createZodEnum(util.objectKeys(this.shape));
    }
}
ZodObject.create = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.strictCreate = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.lazycreate = (shape, params) => {
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results) {
                if (result.result.status === "valid") {
                    return result.result;
                }
            }
            for (const result of results) {
                if (result.result.status === "dirty") {
                    // add issues from dirty option
                    ctx.common.issues.push(...result.ctx.common.issues);
                    return result.result;
                }
            }
            // return invalid
            const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return Promise.all(options.map(async (option) => {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                return {
                    result: await option._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: childCtx,
                    }),
                    ctx: childCtx,
                };
            })).then(handleResults);
        }
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options) {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx,
                });
                if (result.status === "valid") {
                    return result;
                }
                else if (result.status === "dirty" && !dirty) {
                    dirty = { result, ctx: childCtx };
                }
                if (childCtx.common.issues.length) {
                    issues.push(childCtx.common.issues);
                }
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues) => new ZodError(issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
ZodUnion.create = (types, params) => {
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params),
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type) => {
    if (type instanceof ZodLazy) {
        return getDiscriminator(type.schema);
    }
    else if (type instanceof ZodEffects) {
        return getDiscriminator(type.innerType());
    }
    else if (type instanceof ZodLiteral) {
        return [type.value];
    }
    else if (type instanceof ZodEnum) {
        return type.options;
    }
    else if (type instanceof ZodNativeEnum) {
        // eslint-disable-next-line ban/ban
        return Object.keys(type.enum);
    }
    else if (type instanceof ZodDefault) {
        return getDiscriminator(type._def.innerType);
    }
    else if (type instanceof ZodUndefined) {
        return [undefined];
    }
    else if (type instanceof ZodNull) {
        return [null];
    }
    else {
        return null;
    }
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [discriminator],
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return option._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
        else {
            return option._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options) {
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) {
                throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            }
            for (const value of discriminatorValues) {
                if (optionsMap.has(value)) {
                    throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                }
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params),
        });
    }
}
function mergeValues(a, b) {
    const aType = getParsedType(a);
    const bType = getParsedType(b);
    if (a === b) {
        return { valid: true, data: a };
    }
    else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
        const bKeys = util.objectKeys(b);
        const sharedKeys = util
            .objectKeys(a)
            .filter((key) => bKeys.indexOf(key) !== -1);
        const newObj = { ...a, ...b };
        for (const key of sharedKeys) {
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newObj[key] = sharedValue.data;
        }
        return { valid: true, data: newObj };
    }
    else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
        if (a.length !== b.length) {
            return { valid: false };
        }
        const newArray = [];
        for (let index = 0; index < a.length; index++) {
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newArray.push(sharedValue.data);
        }
        return { valid: true, data: newArray };
    }
    else if (aType === ZodParsedType.date &&
        bType === ZodParsedType.date &&
        +a === +b) {
        return { valid: true, data: a };
    }
    else {
        return { valid: false };
    }
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight) => {
            if (isAborted(parsedLeft) || isAborted(parsedRight)) {
                return INVALID;
            }
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.invalid_intersection_types,
                });
                return INVALID;
            }
            if (isDirty(parsedLeft) || isDirty(parsedRight)) {
                status.dirty();
            }
            return { status: status.value, value: merged.data };
        };
        if (ctx.common.async) {
            return Promise.all([
                this._def.left._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
                this._def.right._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
            ]).then(([left, right]) => handleParsed(left, right));
        }
        else {
            return handleParsed(this._def.left._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }), this._def.right._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }));
        }
    }
}
ZodIntersection.create = (left, right, params) => {
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params),
    });
};
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            return INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            status.dirty();
        }
        const items = [...ctx.data]
            .map((item, itemIndex) => {
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema)
                return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        })
            .filter((x) => !!x); // filter nulls
        if (ctx.common.async) {
            return Promise.all(items).then((results) => {
                return ParseStatus.mergeArray(status, results);
            });
        }
        else {
            return ParseStatus.mergeArray(status, items);
        }
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest,
        });
    }
}
ZodTuple.create = (schemas, params) => {
    if (!Array.isArray(schemas)) {
        throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    }
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params),
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for (const key in ctx.data) {
            pairs.push({
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
                value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            });
        }
        if (ctx.common.async) {
            return ParseStatus.mergeObjectAsync(status, pairs);
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) {
            return new ZodRecord({
                keyType: first,
                valueType: second,
                typeName: ZodFirstPartyTypeKind.ZodRecord,
                ...processCreateParams(third),
            });
        }
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second),
        });
    }
}
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.map) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.map,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [...ctx.data.entries()].map(([key, value], index) => {
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"])),
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async () => {
                for (const pair of pairs) {
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") {
                        return INVALID;
                    }
                    if (key.status === "dirty" || value.status === "dirty") {
                        status.dirty();
                    }
                    finalMap.set(key.value, value.value);
                }
                return { status: status.value, value: finalMap };
            });
        }
        else {
            const finalMap = new Map();
            for (const pair of pairs) {
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") {
                    return INVALID;
                }
                if (key.status === "dirty" || value.status === "dirty") {
                    status.dirty();
                }
                finalMap.set(key.value, value.value);
            }
            return { status: status.value, value: finalMap };
        }
    }
}
ZodMap.create = (keyType, valueType, params) => {
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params),
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.set) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.set,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message,
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message,
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements) {
                if (element.status === "aborted")
                    return INVALID;
                if (element.status === "dirty")
                    status.dirty();
                parsedSet.add(element.value);
            }
            return { status: status.value, value: parsedSet };
        }
        const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) {
            return Promise.all(elements).then((elements) => finalizeSet(elements));
        }
        else {
            return finalizeSet(elements);
        }
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: { value: minSize, message: errorUtil.toString(message) },
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: { value: maxSize, message: errorUtil.toString(message) },
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodSet.create = (valueType, params) => {
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params),
    });
};
class ZodFunction extends ZodType {
    constructor() {
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.function) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.function,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        function makeArgsIssue(args, error) {
            return makeIssue({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_arguments,
                    argumentsError: error,
                },
            });
        }
        function makeReturnsIssue(returns, error) {
            return makeIssue({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_return_type,
                    returnTypeError: error,
                },
            });
        }
        const params = { errorMap: ctx.common.contextualErrorMap };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(async function (...args) {
                const error = new ZodError([]);
                const parsedArgs = await me._def.args
                    .parseAsync(args, params)
                    .catch((e) => {
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type
                    .parseAsync(result, params)
                    .catch((e) => {
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        }
        else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(function (...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) {
                    throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
                }
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) {
                    throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
                }
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create()),
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType,
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: (args
                ? args
                : ZodTuple.create([]).rest(ZodUnknown.create())),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params),
        });
    }
}
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
    }
}
ZodLazy.create = (getter, params) => {
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params),
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_literal,
                expected: this._def.value,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
    get value() {
        return this._def.value;
    }
}
ZodLiteral.create = (value, params) => {
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params),
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params),
    });
}
class ZodEnum extends ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    extract(values) {
        return ZodEnum.create(values);
    }
    exclude(values) {
        return ZodEnum.create(this.options.filter((opt) => !values.includes(opt)));
    }
}
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    _parse(input) {
        const nativeEnumValues = util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== ZodParsedType.string &&
            ctx.parsedType !== ZodParsedType.number) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
ZodNativeEnum.create = (values, params) => {
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params),
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.promise &&
            ctx.common.async === false) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.promise,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const promisified = ctx.parsedType === ZodParsedType.promise
            ? ctx.data
            : Promise.resolve(ctx.data);
        return OK(promisified.then((data) => {
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap,
            });
        }));
    }
}
ZodPromise.create = (schema, params) => {
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params),
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects
            ? this._def.schema.sourceType()
            : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg) => {
                addIssueToContext(ctx, arg);
                if (arg.fatal) {
                    status.abort();
                }
                else {
                    status.dirty();
                }
            },
            get path() {
                return ctx.path;
            },
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) {
                return {
                    status: "dirty",
                    value: ctx.data,
                };
            }
            if (ctx.common.async) {
                return Promise.resolve(processed).then((processed) => {
                    return this._def.schema._parseAsync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx,
                    });
                });
            }
            else {
                return this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc
            // effect: RefinementEffect<any>
            ) => {
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) {
                    return Promise.resolve(result);
                }
                if (result instanceof Promise) {
                    throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                }
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inner.status === "aborted")
                    return INVALID;
                if (inner.status === "dirty")
                    status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return { status: status.value, value: inner.value };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((inner) => {
                    if (inner.status === "aborted")
                        return INVALID;
                    if (inner.status === "dirty")
                        status.dirty();
                    return executeRefinement(inner.value).then(() => {
                        return { status: status.value, value: inner.value };
                    });
                });
            }
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (!isValid(base))
                    return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) {
                    throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                }
                return { status: status.value, value: result };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((base) => {
                    if (!isValid(base))
                        return base;
                    return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
                });
            }
        }
        util.assertNever(effect);
    }
}
ZodEffects.create = (schema, effect, params) => {
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params),
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
    return new ZodEffects({
        schema,
        effect: { type: "preprocess", transform: preprocess },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params),
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.undefined) {
            return OK(undefined);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodOptional.create = (type, params) => {
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params),
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.null) {
            return OK(null);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodNullable.create = (type, params) => {
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params),
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === ZodParsedType.undefined) {
            data = this._def.defaultValue();
        }
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
ZodDefault.create = (type, params) => {
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function"
            ? params.default
            : () => params.default,
        ...processCreateParams(params),
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: [],
            },
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx,
            },
        });
        if (isAsync(result)) {
            return result.then((result) => {
                return {
                    status: "valid",
                    value: result.status === "valid"
                        ? result.value
                        : this._def.catchValue({
                            get error() {
                                return new ZodError(newCtx.common.issues);
                            },
                            input: newCtx.data,
                        }),
                };
            });
        }
        else {
            return {
                status: "valid",
                value: result.status === "valid"
                    ? result.value
                    : this._def.catchValue({
                        get error() {
                            return new ZodError(newCtx.common.issues);
                        },
                        input: newCtx.data,
                    }),
            };
        }
    }
    removeCatch() {
        return this._def.innerType;
    }
}
ZodCatch.create = (type, params) => {
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
        ...processCreateParams(params),
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.nan,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
}
ZodNaN.create = (params) => {
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params),
    });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async () => {
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inResult.status === "aborted")
                    return INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return DIRTY(inResult.value);
                }
                else {
                    return this._def.out._parseAsync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx,
                    });
                }
            };
            return handleAsync();
        }
        else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
            if (inResult.status === "aborted")
                return INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value,
                };
            }
            else {
                return this._def.out._parseSync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline,
        });
    }
}
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if (isValid(result)) {
            result.value = Object.freeze(result.value);
        }
        return result;
    }
}
ZodReadonly.create = (type, params) => {
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params),
    });
};
const custom = (check, params = {}, 
/**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */
fatal) => {
    if (check)
        return ZodAny.create().superRefine((data, ctx) => {
            var _a, _b;
            if (!check(data)) {
                const p = typeof params === "function"
                    ? params(data)
                    : typeof params === "string"
                        ? { message: params }
                        : params;
                const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                const p2 = typeof p === "string" ? { message: p } : p;
                ctx.addIssue({ code: "custom", ...p2, fatal: _fatal });
            }
        });
    return ZodAny.create();
};
const late = {
    object: ZodObject.lazycreate,
};
var ZodFirstPartyTypeKind;
(function (ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (
// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`,
}) => custom((data) => data instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = () => stringType().optional();
const onumber = () => numberType().optional();
const oboolean = () => booleanType().optional();
const coerce = {
    string: ((arg) => ZodString.create({ ...arg, coerce: true })),
    number: ((arg) => ZodNumber.create({ ...arg, coerce: true })),
    boolean: ((arg) => ZodBoolean.create({
        ...arg,
        coerce: true,
    })),
    bigint: ((arg) => ZodBigInt.create({ ...arg, coerce: true })),
    date: ((arg) => ZodDate.create({ ...arg, coerce: true })),
};
const NEVER = INVALID;

var z = /*#__PURE__*/Object.freeze({
    __proto__: null,
    defaultErrorMap: errorMap,
    setErrorMap: setErrorMap,
    getErrorMap: getErrorMap,
    makeIssue: makeIssue,
    EMPTY_PATH: EMPTY_PATH,
    addIssueToContext: addIssueToContext,
    ParseStatus: ParseStatus,
    INVALID: INVALID,
    DIRTY: DIRTY,
    OK: OK,
    isAborted: isAborted,
    isDirty: isDirty,
    isValid: isValid,
    isAsync: isAsync,
    get util () { return util; },
    get objectUtil () { return objectUtil; },
    ZodParsedType: ZodParsedType,
    getParsedType: getParsedType,
    ZodType: ZodType,
    ZodString: ZodString,
    ZodNumber: ZodNumber,
    ZodBigInt: ZodBigInt,
    ZodBoolean: ZodBoolean,
    ZodDate: ZodDate,
    ZodSymbol: ZodSymbol,
    ZodUndefined: ZodUndefined,
    ZodNull: ZodNull,
    ZodAny: ZodAny,
    ZodUnknown: ZodUnknown,
    ZodNever: ZodNever,
    ZodVoid: ZodVoid,
    ZodArray: ZodArray,
    ZodObject: ZodObject,
    ZodUnion: ZodUnion,
    ZodDiscriminatedUnion: ZodDiscriminatedUnion,
    ZodIntersection: ZodIntersection,
    ZodTuple: ZodTuple,
    ZodRecord: ZodRecord,
    ZodMap: ZodMap,
    ZodSet: ZodSet,
    ZodFunction: ZodFunction,
    ZodLazy: ZodLazy,
    ZodLiteral: ZodLiteral,
    ZodEnum: ZodEnum,
    ZodNativeEnum: ZodNativeEnum,
    ZodPromise: ZodPromise,
    ZodEffects: ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional: ZodOptional,
    ZodNullable: ZodNullable,
    ZodDefault: ZodDefault,
    ZodCatch: ZodCatch,
    ZodNaN: ZodNaN,
    BRAND: BRAND,
    ZodBranded: ZodBranded,
    ZodPipeline: ZodPipeline,
    ZodReadonly: ZodReadonly,
    custom: custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late: late,
    get ZodFirstPartyTypeKind () { return ZodFirstPartyTypeKind; },
    coerce: coerce,
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    'enum': enumType,
    'function': functionType,
    'instanceof': instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    'null': nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean: oboolean,
    onumber: onumber,
    optional: optionalType,
    ostring: ostring,
    pipeline: pipelineType,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    symbol: symbolType,
    transformer: effectsType,
    tuple: tupleType,
    'undefined': undefinedType,
    union: unionType,
    unknown: unknownType,
    'void': voidType,
    NEVER: NEVER,
    ZodIssueCode: ZodIssueCode,
    quotelessJson: quotelessJson,
    ZodError: ZodError
});

const iComponentProductOptionsSchema = z.object({
    optional: z.boolean(),
    enabled: z.boolean(),
});
const iComponentProductTextSchema = z.object({
    name: z.string().optional(),
    shortDescription: z.string().optional(),
    description: z.string().optional(),
});
const iCompositeProductTextDataSchema = z.object({
    name: z.string(),
    description: z.string(),
    shortDescription: z.string().optional(),
});
const iComponentTextDataSchema = z.object({
    name: z.string(),
    description: z.string(),
});
const iComponentProductTextDataSchema = z.object({
    name: z.string().optional(),
    shortDescription: z.string().optional(),
    description: z.string().optional(),
});
const componentKeySchema = z.any();
const currencySchema = z.any();
const priceValueSchema = z.any();
const metaIdSchema = z.any();
const productIdSchema = z.any();
const productKeySchema = z.any();
const iProductTypeSchema = z.any();
const productNameSchema = z.any();
const iRuleSchema = z.any();
const attributeKeySchema = z.any();
const attributeValuePlainSchema = z.any();
const productVariantIdSchema = z.any();
const productTypeIdSchema = z.any();
const productTypeKeySchema = z.any();
const productTypeNameSchema = z.any();
const productComponentNameSchema = z.any();
const slotKeySchema = z.any();
const placedItemIdSchema = z.any();
const presetIdSchema = z.any();
const iComponentBasicDataSchema = z.object({
    key: componentKeySchema,
});
const iPriceSchema = z.record(currencySchema, priceValueSchema);
const iProductVariantMetaSchema = z.object({
    id: metaIdSchema,
    price: iPriceSchema,
});
const iPriceTypeInfoSchema = z.object({
    ordinal: z.number(),
    key: z.string(),
    name: z.string().nullable(),
    isDefault: z.boolean(),
});
const catalogMetaSchema = z.object({
    metaId: metaIdSchema,
    currencies: z.array(currencySchema),
    catalogKey: z.string().optional(),
    priceTypes: z.array(iPriceTypeInfoSchema).optional(),
});
const iProductKeySchema = z.object({
    productId: productIdSchema,
    productKey: productKeySchema,
});
const iCompositeLogicOrderItemSchema = z.object({
    attributeKey: attributeKeySchema.optional(),
    componentKey: componentKeySchema,
});
const iProductLogicOrderItemSchema = z.object({
    attributeKey: attributeKeySchema,
});
const iComponentProductKeySchema = z.object({
    productId: productIdSchema,
    productKey: productKeySchema,
});
const iComponentProductSchema = iComponentProductKeySchema.and(z.object({
    productId: productIdSchema,
    name: productNameSchema,
    description: z.string().optional(),
    meta: z.record(z.string()),
}));
const iComponentProductVariantKeySchema = z.object({
    variantId: productVariantIdSchema,
    productId: productIdSchema,
});
const iProductVariantAttributesSchema = z.record(attributeKeySchema, attributeValuePlainSchema);
const iProductVariantSchema = z.object({
    attributes: iProductVariantAttributesSchema,
    meta: iProductVariantMetaSchema,
    variantId: productVariantIdSchema,
    productId: productIdSchema,
    productKey: productKeySchema,
});
const iComponentProductVariantSchema = z.object({
    attributes: iProductVariantAttributesSchema,
    meta: iProductVariantMetaSchema,
    variantId: productVariantIdSchema,
    productId: productIdSchema,
    productKey: productKeySchema,
    model3dId: z.number().nullable(),
});
const iComponentSchema = z.object({
    key: componentKeySchema,
    name: productComponentNameSchema,
    type: iProductTypeSchema,
});
const iProductComponentSchema = iComponentSchema
    .extend(iComponentBasicDataSchema.shape)
    .extend(iComponentProductOptionsSchema.shape)
    .extend({
    name: productComponentNameSchema,
    type: iProductTypeSchema,
});
const iCompositeProductDataSchema = iProductKeySchema.and(z.object({
    texts: iCompositeProductTextDataSchema,
}));
const iComponentProductDataSchema = iComponentProductKeySchema.and(z.object({
    texts: iComponentProductTextDataSchema,
    images: z.array(z.object({
        url: z.string(),
    })),
}));
const iComponentDataSchema = z.object({
    texts: iComponentTextDataSchema,
    products: z.array(iComponentProductDataSchema),
});
const iCompositeProductFullDataSchema = z.object({
    product: iCompositeProductDataSchema,
    components: z.record(componentKeySchema, iComponentDataSchema),
});
const iSerializedComponentsSchema = z.record(componentKeySchema, z
    .object({
    id: productVariantIdSchema,
    productId: productIdSchema,
    variantKey: z.string().optional(),
    version: z.number().optional(),
})
    .nullable());
const iSerializedCustomAttributeValueSchema = z.record(componentKeySchema, z.record(attributeKeySchema, attributeValuePlainSchema));
const productLogicOrderSchema = z.array(iProductLogicOrderItemSchema);
const iCompositeProductProductTypeSchema = z.object({
    id: productTypeIdSchema,
    productTypeKey: productTypeKeySchema,
    name: productTypeNameSchema,
    components: z.array(iProductComponentSchema),
});
const compositeLogicOrderSchema = z.array(iCompositeLogicOrderItemSchema);
const iCompositeProductSchema = iProductKeySchema.extend({
    productName: productNameSchema,
    productType: iCompositeProductProductTypeSchema,
    catalogMeta: catalogMetaSchema,
    logicOrder: compositeLogicOrderSchema.optional(),
    rules: z.array(iRuleSchema),
});
const iComponentVariantKeySchema = z.object({
    product: iComponentProductKeySchema,
    variant: iComponentProductVariantKeySchema,
});
const iComponentVariantSchema = z.object({
    product: iComponentProductSchema,
    variant: iComponentProductVariantSchema,
});
const iComponentVariantListSchema = z.object({
    product: iComponentProductSchema,
    variants: z.array(iComponentProductVariantSchema),
});
const iCompositeVariantsSchema = z.object({
    components: z.record(componentKeySchema, z.array(iComponentVariantListSchema.nullable())),
});
const iCompositeProductTypeSchema = z.object({
    name: productTypeNameSchema,
    components: z.array(iComponentSchema),
});
const iSerializedPlacedProductSchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('compositePreset'),
        productId: productIdSchema,
        configState: z.lazy(() => iSerializedCompositeSchema).optional(),
        fromPreset: z
            .object({
            productId: productIdSchema,
            presetId: presetIdSchema,
        })
            .optional(),
    }),
    z.object({
        kind: z.literal('basicVariant'),
        productId: productIdSchema,
        initialVariantId: productVariantIdSchema,
    }),
]);
const iSerializedPlacedItemSchema = z.object({
    id: placedItemIdSchema,
    slot: slotKeySchema,
    product: iSerializedPlacedProductSchema,
    placement: z.any().optional(),
});
const iSerializedCompositeSchema = z.object({
    version: z.number(),
    components: iSerializedComponentsSchema,
    custom: iSerializedCustomAttributeValueSchema,
    meta: z.record(z.any()).optional(),
    slots: z.record(slotKeySchema, z.array(iSerializedPlacedItemSchema)).optional(),
});
const iProductSchema = iProductKeySchema.extend({
    productType: iProductTypeSchema,
    productName: productNameSchema,
    catalogMeta: catalogMetaSchema,
    logicOrder: productLogicOrderSchema.optional(),
});
const iCompositeProductOmitRulesSchema = iCompositeProductSchema.omit({ rules: true });
const iCompositeVariantKeySchema = z.object({
    components: z.record(componentKeySchema, iComponentVariantKeySchema.nullable()),
});
const iCompositeVariantSchema = z.object({
    components: z.record(componentKeySchema, iComponentVariantSchema.nullable()),
    custom: z.record(componentKeySchema, z.record(attributeKeySchema, attributeValuePlainSchema)).optional(),
});
const iCompositeProductVariantWithRulesSchema = iCompositeVariantsSchema.and(z.object({
    rules: z.array(iRuleSchema),
}));

const PRICE_TYPE_SEPARATOR = '/';
const PRICE_TYPE_PREFIX_PATTERN = new RegExp(`^PT(\\d+)${PRICE_TYPE_SEPARATOR}`);
const DEFAULT_PRICE_TYPE_ORDINAL = 1;
function priceKey(ordinal, currency) {
    if (ordinal === DEFAULT_PRICE_TYPE_ORDINAL) {
        return currency;
    }
    return `PT${ordinal}${PRICE_TYPE_SEPARATOR}${currency}`;
}
function parsePriceKey(key) {
    const match = PRICE_TYPE_PREFIX_PATTERN.exec(key);
    if (!match) {
        return { ordinal: DEFAULT_PRICE_TYPE_ORDINAL, currency: key };
    }
    return { ordinal: Number(match[1]), currency: key.slice(match[0].length) };
}
function projectPrice(price, ordinal) {
    const result = {};
    for (const key of Object.keys(price)) {
        const parsed = parsePriceKey(key);
        if (parsed.ordinal === ordinal) {
            result[parsed.currency] = price[key];
        }
    }
    return result;
}
function priceTypeOrdinals(price) {
    const ordinals = new Set();
    for (const key of Object.keys(price)) {
        ordinals.add(parsePriceKey(key).ordinal);
    }
    return [...ordinals].sort((a, b) => a - b);
}
function zeroPrice(currencies) {
    const price = {};
    for (const currency of currencies) {
        price[currency] = 0;
    }
    return price;
}
function addPrice(a, b) {
    var _a;
    const result = Object.assign({}, a);
    for (const currency of Object.keys(b)) {
        result[currency] = ((_a = result[currency]) !== null && _a !== void 0 ? _a : 0) + b[currency];
    }
    return result;
}
function negatePrice(a) {
    const result = {};
    for (const currency of Object.keys(a)) {
        result[currency] = -a[currency];
    }
    return result;
}
function subPrice(a, b) {
    return addPrice(a, negatePrice(b));
}
function sumPrices(prices) {
    return prices.reduce((acc, cur) => addPrice(acc, cur));
}
function mulPriceByScalar(price, scalar) {
    const result = {};
    for (const currency of Object.keys(price)) {
        result[currency] = price[currency] * scalar;
    }
    return result;
}
function toCents(price) {
    const result = {};
    for (const currency of Object.keys(price)) {
        result[currency] = Math.round(price[currency] * 100);
    }
    return result;
}
function fromCents(price) {
    const result = {};
    for (const currency of Object.keys(price)) {
        result[currency] = price[currency] / 100;
    }
    return result;
}
function getCurrencies(price) {
    return Object.keys(price);
}
function getCurrencyValue(price, currency) {
    return price[currency];
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function isConditionalAcceptedItems(acceptedItems) {
    return acceptedItems.length > 0 && 'condition' in acceptedItems[0];
}
function isBagPlacement(placement) {
    return placement.kind === 'bag';
}
function getSlotSpace(placement) {
    return placement.kind === 'bag' ? undefined : placement.space;
}
function withSlotSpace(placement, space) {
    if (placement.kind === 'bag')
        return placement;
    const { space: _space } = placement, rest = __rest(placement, ["space"]);
    return space !== undefined ? Object.assign(Object.assign({}, rest), { space }) : rest;
}

function resolveAcceptedSlotItems(acceptedItems, state) {
    if (!isConditionalAcceptedItems(acceptedItems)) {
        return acceptedItems;
    }
    for (const rule of acceptedItems) {
        if (isConditionActive(rule.condition, state)) {
            return rule.acceptedItems;
        }
    }
    return [];
}
function getAllAcceptedSlotItems(acceptedItems) {
    if (!isConditionalAcceptedItems(acceptedItems)) {
        return acceptedItems;
    }
    return acceptedItems.flatMap((rule) => rule.acceptedItems);
}
function evaluateBinding(value, ctx) {
    if (typeof value === 'number') {
        return value;
    }
    const fn = new Function('ctx', value.fn);
    return fn(ctx);
}
function resolveAxisRange(axis, ctx) {
    const resolved = {};
    if (axis.min !== undefined)
        resolved.min = evaluateBinding(axis.min, ctx);
    if (axis.max !== undefined)
        resolved.max = evaluateBinding(axis.max, ctx);
    return resolved;
}
function resolveBoundary(boundary, ctx) {
    const resolved = {};
    if (boundary.x)
        resolved.x = resolveAxisRange(boundary.x, ctx);
    if (boundary.y)
        resolved.y = resolveAxisRange(boundary.y, ctx);
    if (boundary.z)
        resolved.z = resolveAxisRange(boundary.z, ctx);
    return resolved;
}
function resolveOrigin(origin, ctx) {
    return {
        x: (origin === null || origin === void 0 ? void 0 : origin.x) === undefined ? 0 : evaluateBinding(origin.x, ctx),
        y: (origin === null || origin === void 0 ? void 0 : origin.y) === undefined ? 0 : evaluateBinding(origin.y, ctx),
        z: (origin === null || origin === void 0 ? void 0 : origin.z) === undefined ? 0 : evaluateBinding(origin.z, ctx),
    };
}
function resolvePartAxis(axis, partBbox, key, ctx) {
    if (!axis)
        return 0;
    const base = axis.edge && partBbox ? partBbox[axis.edge][key] : 0;
    const offset = axis.offset === undefined ? 0 : evaluateBinding(axis.offset, ctx);
    return base + offset;
}
function resolvePartOrigin(origin, partBbox, ctx) {
    return {
        x: resolvePartAxis(origin === null || origin === void 0 ? void 0 : origin.x, partBbox, 'x', ctx),
        y: resolvePartAxis(origin === null || origin === void 0 ? void 0 : origin.y, partBbox, 'y', ctx),
        z: resolvePartAxis(origin === null || origin === void 0 ? void 0 : origin.z, partBbox, 'z', ctx),
    };
}
function resolveSpaceOrigin(space, ctx, partToComponent) {
    if (!space || space.kind === 'global') {
        return resolveOrigin(space === null || space === void 0 ? void 0 : space.origin, ctx);
    }
    const componentKey = partToComponent === null || partToComponent === void 0 ? void 0 : partToComponent(space.partKey);
    const partBbox = componentKey ? ctx.bbox[componentKey] : undefined;
    return resolvePartOrigin(space.origin, partBbox, ctx);
}

const SCENE_NESTING = {
    part: { allowedParents: ['root', 'part'], allowedChildren: ['part', 'slot', 'staticModel'] },
    slot: { allowedParents: ['root', 'part'], allowedChildren: [] },
    staticModel: { allowedParents: ['root', 'part'], allowedChildren: [] },
    light: { allowedParents: ['root'], allowedChildren: [] },
    camera: { allowedParents: ['root'], allowedChildren: [] },
};
function canNestSceneNode(child, parent) {
    return (SCENE_NESTING[child].allowedParents.includes(parent) &&
        (parent === 'root' || SCENE_NESTING[parent].allowedChildren.includes(child)));
}
function sceneNodeId(node) {
    return `${node.kind}:${node.key}`;
}
function partToSceneNode(part) {
    var _a, _b;
    const isRoot = ((_a = part.layout) === null || _a === void 0 ? void 0 : _a.type) === 'rootPartLayout';
    return {
        kind: 'part',
        key: part.partKey,
        name: part.partName,
        parentPartKey: isRoot ? null : part.parentPartKey || null,
        attachment: ((_b = part.layout) === null || _b === void 0 ? void 0 : _b.type) === 'childPartLayout'
            ? {
                kind: 'jointPoint',
                parentJointPointKey: part.layout.parentJointPointKey,
                mainJointPointKey: part.layout.mainJointPointKey,
            }
            : { kind: 'jointPoint' },
    };
}
function slotToSceneNode(slot) {
    var _a;
    const space = (_a = getSlotSpace(slot.placement)) !== null && _a !== void 0 ? _a : { kind: 'global' };
    return {
        kind: 'slot',
        key: slot.key,
        name: slot.name,
        parentPartKey: space.kind === 'part' ? space.partKey : null,
        attachment: { kind: 'space', space },
    };
}

const MaterialMaps = {
    map: 'map',
    normalMap: 'normalMap',
    aoMap: 'aoMap',
    metalnessMap: 'metalnessMap',
    roughnessMap: 'roughnessMap',
    emissiveMap: 'emissiveMap',
    envMap: 'envMap',
    alphaMap: 'alphaMap',
    bumpMap: 'bumpMap',
    displacementMap: 'displacementMap',
    lightMap: 'lightMap',
};
const isMaterialMap = (name) => name in MaterialMaps;
const MaterialTypes = {
    MeshStandardMaterial: 'MeshStandardMaterial',
    MeshPhysicalMaterial: 'MeshPhysicalMaterial',
};
const isMaterialType = (name) => name in MaterialTypes;

function getUniqueName(name, usedNames) {
    var _a;
    const used = new Set(usedNames);
    const match = name.match(/^(.*?)(?: \((\d+)\))?$/);
    const base = (_a = match === null || match === void 0 ? void 0 : match[1]) !== null && _a !== void 0 ? _a : '';
    let i = (match === null || match === void 0 ? void 0 : match[2]) ? Number(match[2]) : 0;
    let candidate = name;
    if (!used.has(candidate)) {
        return candidate;
    }
    console.log('used', used);
    console.log('candidate', candidate);
    do {
        i++;
        candidate = `${base} (${i})`;
    } while (used.has(candidate));
    return candidate;
}

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var slugify$2 = {exports: {}};

var slugify$1 = slugify$2.exports;

var hasRequiredSlugify;

function requireSlugify () {
	if (hasRequiredSlugify) return slugify$2.exports;
	hasRequiredSlugify = 1;
	(function (module, exports) {
(function (name, root, factory) {
		  {
		    module.exports = factory();
		    module.exports['default'] = factory();
		  }
		}('slugify', slugify$1, function () {
		  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}');
		  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}');

		  function replace (string, options) {
		    if (typeof string !== 'string') {
		      throw new Error('slugify: string argument expected')
		    }

		    options = (typeof options === 'string')
		      ? {replacement: options}
		      : options || {};

		    var locale = locales[options.locale] || {};

		    var replacement = options.replacement === undefined ? '-' : options.replacement;

		    var trim = options.trim === undefined ? true : options.trim;

		    var slug = string.normalize().split('')
		      // replace characters based on charMap
		      .reduce(function (result, ch) {
		        var appendChar = locale[ch];
		        if (appendChar === undefined) appendChar = charMap[ch];
		        if (appendChar === undefined) appendChar = ch;
		        if (appendChar === replacement) appendChar = ' ';
		        return result + appendChar
		          // remove not allowed characters
		          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
		      }, '');

		    if (options.strict) {
		      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
		    }

		    if (trim) {
		      slug = slug.trim();
		    }

		    // Replace spaces with replacement character, treating multiple consecutive
		    // spaces as a single space.
		    slug = slug.replace(/\s+/g, replacement);

		    if (options.lower) {
		      slug = slug.toLowerCase();
		    }

		    return slug
		  }

		  replace.extend = function (customMap) {
		    Object.assign(charMap, customMap);
		  };

		  return replace
		})); 
	} (slugify$2));
	return slugify$2.exports;
}

var slugifyExports = requireSlugify();
var slugify = /*@__PURE__*/getDefaultExportFromCjs(slugifyExports);

slugify.extend({ '©': '' });
const generateKey = (name, previousKeys) => {
    const safeName = name.replace(/\//g, '-');
    const key = slugify(safeName, {
        replacement: '-',
        remove: undefined,
        lower: false,
        strict: true,
        trim: true,
    });
    if (!previousKeys || previousKeys.length === 0) {
        return key;
    }
    const postfix = findNextKeyPostfix(previousKeys, key);
    if (postfix) {
        return `${key}--${postfix}`;
    }
    return key;
};
const findNextKeyPostfix = (keys, name) => {
    if (keys.length === 0) {
        return undefined;
    }
    const key = generateKey(name);
    const hasExactMatch = keys.includes(key);
    const regex = new RegExp(`^${key}--(\\d+)$`);
    const postfixes = keys
        .map((k) => regex.exec(k))
        .filter((m) => m !== null)
        .map((m) => parseInt(m[1], 10));
    if (!hasExactMatch && postfixes.length === 0) {
        return undefined;
    }
    if (postfixes.length === 0) {
        return 1;
    }
    return Math.max(...postfixes) + 1;
};
function isKeyValid(key) {
    if (key === generateKey(key)) {
        return true;
    }
    const match = /^(.+?)--(\d+)$/.exec(key);
    if (match) {
        const [, base] = match;
        return base === generateKey(base);
    }
    return false;
}

const MEGABYTE = 1024 * 1024;
const MAX_FILE_SIZE_BYTES = 40 * MEGABYTE;
const MAX_MODEL_FILE_SIZE_BYTES = 20 * MEGABYTE;
const MAX_IMAGE_FILE_SIZE_BYTES = 32 * MEGABYTE;
const MAX_PDF_LOGO_SIZE = MEGABYTE;
const StandardAttributes = {
    model3dId: '_model3dId',
};

class Versioning {
    constructor(versioningObj, defaultVersion = 1) {
        this.versioningObj = versioningObj;
        this.defaultVersion = defaultVersion;
    }
    get currentVersion() {
        var _a, _b;
        return (_b = (_a = this.versioningObj) === null || _a === void 0 ? void 0 : _a.version) !== null && _b !== void 0 ? _b : this.defaultVersion;
    }
    isEq(version) {
        return this.currentVersion === version;
    }
    isEqOrGreaterThan(version) {
        return this.currentVersion > version;
    }
}

const IMAGE_FORMATS = {
    jpg: {
        extensions: ['jpg', 'jpeg'],
        mimeTypes: ['image/jpeg'],
    },
    png: {
        extensions: ['png'],
        mimeTypes: ['image/png'],
    },
    svg: {
        extensions: ['svg'],
        mimeTypes: ['image/svg+xml'],
        isVector: true,
    },
    webp: {
        extensions: ['webp'],
        mimeTypes: ['image/webp'],
    },
    gif: {
        extensions: ['gif'],
        mimeTypes: ['image/gif'],
    },
    bmp: {
        extensions: ['bmp'],
        mimeTypes: ['image/bmp'],
    },
    tiff: {
        extensions: ['tif', 'tiff'],
        mimeTypes: ['image/tiff'],
    },
};

const getImageFormat = (args) => {
    var _a;
    return (_a = Object.entries(IMAGE_FORMATS)
        .find(([_, { mimeTypes, extensions }]) => {
        if (args.extension) {
            return extensions.includes(args.extension);
        }
        else if (args.mimeType) {
            return mimeTypes.includes(args.mimeType);
        }
    })) === null || _a === void 0 ? void 0 : _a.at(0);
};
const getImageFormatDefinition = (args) => {
    const format = getImageFormat(args);
    if (!format) {
        return undefined;
    }
    return IMAGE_FORMATS[format];
};

class BomRuleError extends Error {
    constructor(message, context) {
        super(message);
        this.context = context;
        this.name = 'BomRuleError';
    }
}

class BomRule {
    get key() {
        return this.dto.key;
    }
    get name() {
        return this.dto.name;
    }
    get fn() {
        return this.dto.fn;
    }
    get usedProductKeys() {
        return this.dto.deps.productKeys;
    }
    get usedSKUs() {
        return this.dto.deps.skus;
    }
    constructor(dto) {
        this.dto = dto;
        this.contextKeys = ['product', 'meta'];
        this.actionKeys = ['addBomItemByProductKey', 'addBomItemBySKU'];
        this.validateKey(dto.key);
        this.validateName(dto.name);
        BomRule.validateJs(dto.fn);
        this.jsFunction = this.createJsFunction();
    }
    static createFromSource(params) {
        const { source, key, name } = params;
        const fn = this.compileSource(source);
        const deps = this.collectDependencies(source);
        return new BomRule({ key, name, source, fn, deps });
    }
    execute(context, bomItemFactory) {
        const actions = {
            addBomItemByProductKey(productKey, amount) {
                bomItemFactory.addProductKeyBomItem(productKey, amount);
            },
            addBomItemBySKU(sku, amount) {
                bomItemFactory.addSkuBomItem(sku, amount);
            },
        };
        const contextParams = this.contextKeys.map((key) => context[key]);
        const actionParams = this.actionKeys.map((key) => actions[key]);
        this.jsFunction.apply(null, [...contextParams, ...actionParams]);
    }
    static compileSource(source) {
        this.validateJs(source);
        return source;
    }
    static collectDependencies(source) {
        const productKeys = [];
        const skus = [];
        const sourceWithoutComments = this.removeComments(source);
        const addBomByProductKeyRegex = /addBomItemByProductKey\s*\(\s*(['"`])((?:(?!\1)[^])*)\1/g;
        let match;
        while ((match = addBomByProductKeyRegex.exec(sourceWithoutComments)) !== null) {
            const productKey = match[2];
            if (!productKeys.includes(productKey)) {
                productKeys.push(productKey);
            }
        }
        const addBomBySKURegex = /addBomItemBySKU\s*\(\s*(['"`])((?:(?!\1)[^])*)\1/g;
        while ((match = addBomBySKURegex.exec(sourceWithoutComments)) !== null) {
            const sku = match[2];
            if (!skus.includes(sku)) {
                skus.push(sku);
            }
        }
        return { productKeys, skus };
    }
    validateKey(key) {
        this.validateNotEmpty(key, 'key cannot be empty');
    }
    validateName(name) {
        this.validateNotEmpty(name, 'name cannot be empty');
    }
    validateNotEmpty(value, message) {
        if (value.trim() === '') {
            throw new Error(message);
        }
    }
    static validateJs(source) {
        const sourceWithoutComments = this.removeComments(source);
        this.validateBomFunctionCalls(source, sourceWithoutComments, 'addBomItemByProductKey', /addBomItemByProductKey\s*\(\s*([^,)]+)/g, 'productKey');
        this.validateBomFunctionCalls(source, sourceWithoutComments, 'addBomItemBySKU', /addBomItemBySKU\s*\(\s*([^,)]+)/g, 'sku');
    }
    static validateBomFunctionCalls(source, sourceWithoutComments, functionName, regex, paramName) {
        let match;
        while ((match = regex.exec(sourceWithoutComments)) !== null) {
            const firstArg = match[1].trim();
            const matchPosition = match.index;
            const isStaticString = (firstArg.startsWith("'") && firstArg.endsWith("'")) ||
                (firstArg.startsWith('"') && firstArg.endsWith('"')) ||
                (firstArg.startsWith('`') && firstArg.endsWith('`') && !firstArg.includes('${'));
            if (!isStaticString) {
                const { lineNumber, columnNumber } = this.getPositionInfo(source, matchPosition);
                throw new BomRuleError(`${functionName} must be called with a static string literal as the first argument. Found: ${firstArg}`, {
                    lineNumber,
                    columnNumber,
                    position: { from: matchPosition, to: matchPosition + match[0].length },
                });
            }
            if (isStaticString) {
                const value = firstArg.slice(1, -1);
                if (value.trim() === '') {
                    const { lineNumber, columnNumber } = this.getPositionInfo(source, matchPosition);
                    throw new BomRuleError(`${functionName} ${paramName} cannot be an empty string. Found: ${firstArg}`, {
                        lineNumber,
                        columnNumber,
                        position: { from: matchPosition, to: matchPosition + match[0].length },
                    });
                }
            }
        }
    }
    createJsFunction() {
        return new Function(...this.contextKeys, ...this.actionKeys, this.dto.fn);
    }
    static removeComments(source) {
        let result = source.replace(/\/\*[\s\S]*?\*\//g, '');
        result = result.replace(/\/\/.*$/gm, '');
        return result;
    }
    static getPositionInfo(source, position) {
        const lines = source.substring(0, position).split('\n');
        const lineNumber = lines.length;
        const columnNumber = lines[lines.length - 1].length + 1;
        return { lineNumber, columnNumber };
    }
}

class BomCalculator {
    constructor(rules) {
        this.rules = rules.map((rule) => new BomRule(rule));
    }
    execute(context, bomList) {
        const productKeys = new Map();
        for (const rule of this.rules) {
            rule.execute(context, bomList);
        }
        return productKeys;
    }
    getUsedProductKeys() {
        const set = new Set();
        for (const rule of this.rules) {
            rule.usedProductKeys.forEach((productKey) => set.add(productKey));
        }
        return Array.from(set);
    }
    getUsedSKUs() {
        const set = new Set();
        for (const rule of this.rules) {
            rule.usedSKUs.forEach((sku) => set.add(sku));
        }
        return Array.from(set);
    }
}

const NA = 'NA';
function isSkippingMetaId(metaId) {
    return ['', NA].includes(metaId);
}

class BomList {
    constructor(registry) {
        this.registry = registry;
        this.bomItems = new Map();
    }
    getTotalPrice() {
        const firstBomRecordWithPrice = this.registry.find((item) => item.price);
        if (!firstBomRecordWithPrice) {
            return {};
        }
        const currencies = firstBomRecordWithPrice.price ? getCurrencies(firstBomRecordWithPrice.price) : [];
        let total = zeroPrice(currencies);
        this.bomItems.forEach((amount, metaId) => {
            const priceInCents = toCents(this.getBomPrice(metaId));
            const bomItemPrice = mulPriceByScalar(priceInCents, amount);
            total = addPrice(total, bomItemPrice);
        });
        return fromCents(total);
    }
    getBomList() {
        const items = [];
        for (const [key, value] of this.bomItems.entries()) {
            items.push({
                metaId: key,
                amount: value,
            });
        }
        return items;
    }
    getBomRecord() {
        return this.bomItems;
    }
    clear() {
        this.bomItems.clear();
    }
    addExternalBomItem(metaId, amount) {
        this.addBomItemAmount(metaId, amount);
    }
    addMetaIdBomItem(metaId, amount) {
        const bomItem = this.registry.find((it) => it.metaId === metaId);
        if (!bomItem) {
            throw new Error(`Bom item with metaId "${metaId}" not found.`);
        }
        this.addBomItemAmount(bomItem.metaId, amount);
    }
    addSkuBomItem(sku, amount) {
        const bomItem = this.registry.find((it) => it.data.sku === sku);
        if (!bomItem) {
            throw new Error(`Bom item for sku "${sku}" not found.`);
        }
        this.addBomItemAmount(bomItem.metaId, amount);
    }
    addProductKeyBomItem(productKey, amount) {
        const bomItem = this.registry.find((it) => it.data.productKey === productKey);
        if (!bomItem) {
            throw new Error(`Bom item for productKey "${productKey}" not found.`);
        }
        this.addBomItemAmount(bomItem.metaId, amount);
    }
    addBomItemAmount(metaId, amount) {
        if (isSkippingMetaId(metaId)) {
            return;
        }
        const itemAmount = this.bomItems.get(metaId);
        if (itemAmount === undefined) {
            this.bomItems.set(metaId, amount);
        }
        else {
            this.bomItems.set(metaId, itemAmount + amount);
        }
    }
    getBomPrice(metaId) {
        var _a;
        const bomItem = this.registry.find((it) => it.metaId === metaId);
        return (_a = bomItem === null || bomItem === void 0 ? void 0 : bomItem.price) !== null && _a !== void 0 ? _a : {};
    }
}

function hasHqrDefaultImage(config) {
    if (!config || config.length === 0)
        return false;
    return config.some((entry) => !entry.combination || entry.combination.length === 0);
}
function getHqrDefaultImage(config) {
    if (!config)
        return null;
    const defaultEntry = config.find((entry) => !entry.combination || entry.combination.length === 0);
    return (defaultEntry === null || defaultEntry === void 0 ? void 0 : defaultEntry.image) || null;
}

const POSITIVE_INFINITY = { x: Infinity, y: Infinity, z: Infinity };
const NEGATIVE_INFINITY = { x: -Infinity, y: -Infinity, z: -Infinity };
function emptyAABB() {
    return { min: Object.assign({}, POSITIVE_INFINITY), max: Object.assign({}, NEGATIVE_INFINITY) };
}
function isEmpty(a) {
    return a.min.x > a.max.x || a.min.y > a.max.y || a.min.z > a.max.z;
}
function unionAABB(a, b) {
    if (isEmpty(a))
        return b;
    if (isEmpty(b))
        return a;
    return {
        min: {
            x: Math.min(a.min.x, b.min.x),
            y: Math.min(a.min.y, b.min.y),
            z: Math.min(a.min.z, b.min.z),
        },
        max: {
            x: Math.max(a.max.x, b.max.x),
            y: Math.max(a.max.y, b.max.y),
            z: Math.max(a.max.z, b.max.z),
        },
    };
}
function translateAABB(a, t) {
    if (isEmpty(a))
        return a;
    return {
        min: { x: a.min.x + t.x, y: a.min.y + t.y, z: a.min.z + t.z },
        max: { x: a.max.x + t.x, y: a.max.y + t.y, z: a.max.z + t.z },
    };
}
function transformAABB(a, t) {
    if (isEmpty(a))
        return a;
    const noRotation = t.rotation.x === 0 && t.rotation.y === 0 && t.rotation.z === 0;
    if (noRotation) {
        return translateAABB(a, t.translation);
    }
    const corners = [
        { x: a.min.x, y: a.min.y, z: a.min.z },
        { x: a.min.x, y: a.min.y, z: a.max.z },
        { x: a.min.x, y: a.max.y, z: a.min.z },
        { x: a.min.x, y: a.max.y, z: a.max.z },
        { x: a.max.x, y: a.min.y, z: a.min.z },
        { x: a.max.x, y: a.min.y, z: a.max.z },
        { x: a.max.x, y: a.max.y, z: a.min.z },
        { x: a.max.x, y: a.max.y, z: a.max.z },
    ];
    let rotated = emptyAABB();
    for (const c of corners) {
        const r = rotateXYZ(c, t.rotation);
        rotated = unionAABB(rotated, { min: r, max: r });
    }
    return translateAABB(rotated, t.translation);
}
function transformAABBByMat4(a, m) {
    if (isEmpty(a))
        return a;
    const corners = [
        { x: a.min.x, y: a.min.y, z: a.min.z },
        { x: a.min.x, y: a.min.y, z: a.max.z },
        { x: a.min.x, y: a.max.y, z: a.min.z },
        { x: a.min.x, y: a.max.y, z: a.max.z },
        { x: a.max.x, y: a.min.y, z: a.min.z },
        { x: a.max.x, y: a.min.y, z: a.max.z },
        { x: a.max.x, y: a.max.y, z: a.min.z },
        { x: a.max.x, y: a.max.y, z: a.max.z },
    ];
    let out = emptyAABB();
    for (const c of corners) {
        const p = m.applyToPoint(c);
        out = unionAABB(out, { min: p, max: p });
    }
    return out;
}
function boundaryToAABB(b) {
    var _a, _b, _c, _d, _e, _f;
    const lo = (v) => (typeof v === 'number' ? v : -Infinity);
    const hi = (v) => (typeof v === 'number' ? v : Infinity);
    return {
        min: {
            x: lo((_a = b.x) === null || _a === void 0 ? void 0 : _a.min),
            y: lo((_b = b.y) === null || _b === void 0 ? void 0 : _b.min),
            z: lo((_c = b.z) === null || _c === void 0 ? void 0 : _c.min),
        },
        max: {
            x: hi((_d = b.x) === null || _d === void 0 ? void 0 : _d.max),
            y: hi((_e = b.y) === null || _e === void 0 ? void 0 : _e.max),
            z: hi((_f = b.z) === null || _f === void 0 ? void 0 : _f.max),
        },
    };
}
function containsAABB(outer, inner) {
    if (isEmpty(inner))
        return true;
    if (isEmpty(outer))
        return false;
    return (inner.min.x >= outer.min.x &&
        inner.min.y >= outer.min.y &&
        inner.min.z >= outer.min.z &&
        inner.max.x <= outer.max.x &&
        inner.max.y <= outer.max.y &&
        inner.max.z <= outer.max.z);
}
function sizeAlong(a, axis) {
    if (isEmpty(a))
        return 0;
    switch (axis) {
        case '+x':
        case '-x':
            return a.max.x - a.min.x;
        case '+y':
        case '-y':
            return a.max.y - a.min.y;
        case '+z':
        case '-z':
            return a.max.z - a.min.z;
    }
}
function axisVec(axis, magnitude) {
    switch (axis) {
        case '+x':
            return { x: magnitude, y: 0, z: 0 };
        case '-x':
            return { x: -magnitude, y: 0, z: 0 };
        case '+y':
            return { x: 0, y: magnitude, z: 0 };
        case '-y':
            return { x: 0, y: -magnitude, z: 0 };
        case '+z':
            return { x: 0, y: 0, z: magnitude };
        case '-z':
            return { x: 0, y: 0, z: -magnitude };
    }
}
function addVec(a, b) {
    return { x: a.x + b.x, y: a.y + b.y, z: a.z + b.z };
}
function subVec(a, b) {
    return { x: a.x - b.x, y: a.y - b.y, z: a.z - b.z };
}
function centerAABB(a) {
    return {
        x: (a.min.x + a.max.x) / 2,
        y: (a.min.y + a.max.y) / 2,
        z: (a.min.z + a.max.z) / 2,
    };
}
function scaleVec(v, s) {
    return { x: v.x * s, y: v.y * s, z: v.z * s };
}
function rotateXYZ(p, r) {
    const cx = Math.cos(r.x);
    const sx = Math.sin(r.x);
    const y = p.y * cx - p.z * sx;
    let z = p.y * sx + p.z * cx;
    let x = p.x;
    const cy = Math.cos(r.y);
    const sy = Math.sin(r.y);
    const x1 = x * cy + z * sy;
    const z1 = -x * sy + z * cy;
    x = x1;
    z = z1;
    const cz = Math.cos(r.z);
    const sz = Math.sin(r.z);
    const x2 = x * cz - y * sz;
    const y2 = x * sz + y * cz;
    return { x: x2, y: y2, z };
}

class Mat4 {
    constructor(elements) {
        if (elements.length !== 16) {
            throw new Error(`Mat4 requires 16 elements, got ${elements.length}`);
        }
        this.elements = elements;
    }
    static identity() {
        return new Mat4([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
    }
    static fromTransform(t) {
        const tr = Mat4.makeTranslation(t.translation);
        const rx = Mat4.makeRotationX(t.rotation.x);
        const ry = Mat4.makeRotationY(t.rotation.y);
        const rz = Mat4.makeRotationZ(t.rotation.z);
        return tr.multiply(rz).multiply(ry).multiply(rx);
    }
    static makeRotationX(angle) {
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        return new Mat4([1, 0, 0, 0, 0, c, s, 0, 0, -s, c, 0, 0, 0, 0, 1]);
    }
    static makeRotationY(angle) {
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        return new Mat4([c, 0, -s, 0, 0, 1, 0, 0, s, 0, c, 0, 0, 0, 0, 1]);
    }
    static makeRotationZ(angle) {
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        return new Mat4([c, s, 0, 0, -s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
    }
    static makeTranslation(t) {
        return new Mat4([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t.x, t.y, t.z, 1]);
    }
    static makeBasis(a, b, c) {
        return new Mat4([a.x, a.y, a.z, 0, b.x, b.y, b.z, 0, c.x, c.y, c.z, 0, 0, 0, 0, 1]);
    }
    multiply(other) {
        const a = this.elements;
        const b = other.elements;
        const out = new Array(16);
        for (let col = 0; col < 4; col++) {
            for (let row = 0; row < 4; row++) {
                let sum = 0;
                for (let k = 0; k < 4; k++) {
                    sum += a[k * 4 + row] * b[col * 4 + k];
                }
                out[col * 4 + row] = sum;
            }
        }
        return new Mat4(out);
    }
    invert() {
        const e = this.elements;
        const m11 = e[0], m21 = e[1], m31 = e[2], m41 = e[3];
        const m12 = e[4], m22 = e[5], m32 = e[6], m42 = e[7];
        const m13 = e[8], m23 = e[9], m33 = e[10], m43 = e[11];
        const m14 = e[12], m24 = e[13], m34 = e[14], m44 = e[15];
        const t11 = m23 * m34 * m42 - m24 * m33 * m42 + m24 * m32 * m43 - m22 * m34 * m43 - m23 * m32 * m44 + m22 * m33 * m44;
        const t12 = m14 * m33 * m42 - m13 * m34 * m42 - m14 * m32 * m43 + m12 * m34 * m43 + m13 * m32 * m44 - m12 * m33 * m44;
        const t13 = m13 * m24 * m42 - m14 * m23 * m42 + m14 * m22 * m43 - m12 * m24 * m43 - m13 * m22 * m44 + m12 * m23 * m44;
        const t14 = m14 * m23 * m32 - m13 * m24 * m32 - m14 * m22 * m33 + m12 * m24 * m33 + m13 * m22 * m34 - m12 * m23 * m34;
        const det = m11 * t11 + m21 * t12 + m31 * t13 + m41 * t14;
        if (det === 0) {
            throw new Error('Mat4.invert: matrix is singular (determinant is 0)');
        }
        const d = 1 / det;
        const r = new Array(16);
        r[0] = t11 * d;
        r[1] =
            (m24 * m33 * m41 - m23 * m34 * m41 - m24 * m31 * m43 + m21 * m34 * m43 + m23 * m31 * m44 - m21 * m33 * m44) * d;
        r[2] =
            (m22 * m34 * m41 - m24 * m32 * m41 + m24 * m31 * m42 - m21 * m34 * m42 - m22 * m31 * m44 + m21 * m32 * m44) * d;
        r[3] =
            (m23 * m32 * m41 - m22 * m33 * m41 - m23 * m31 * m42 + m21 * m33 * m42 + m22 * m31 * m43 - m21 * m32 * m43) * d;
        r[4] = t12 * d;
        r[5] =
            (m13 * m34 * m41 - m14 * m33 * m41 + m14 * m31 * m43 - m11 * m34 * m43 - m13 * m31 * m44 + m11 * m33 * m44) * d;
        r[6] =
            (m14 * m32 * m41 - m12 * m34 * m41 - m14 * m31 * m42 + m11 * m34 * m42 + m12 * m31 * m44 - m11 * m32 * m44) * d;
        r[7] =
            (m12 * m33 * m41 - m13 * m32 * m41 + m13 * m31 * m42 - m11 * m33 * m42 - m12 * m31 * m43 + m11 * m32 * m43) * d;
        r[8] = t13 * d;
        r[9] =
            (m14 * m23 * m41 - m13 * m24 * m41 - m14 * m21 * m43 + m11 * m24 * m43 + m13 * m21 * m44 - m11 * m23 * m44) * d;
        r[10] =
            (m12 * m24 * m41 - m14 * m22 * m41 + m14 * m21 * m42 - m11 * m24 * m42 - m12 * m21 * m44 + m11 * m22 * m44) * d;
        r[11] =
            (m13 * m22 * m41 - m12 * m23 * m41 - m13 * m21 * m42 + m11 * m23 * m42 + m12 * m21 * m43 - m11 * m22 * m43) * d;
        r[12] = t14 * d;
        r[13] =
            (m13 * m24 * m31 - m14 * m23 * m31 + m14 * m21 * m33 - m11 * m24 * m33 - m13 * m21 * m34 + m11 * m23 * m34) * d;
        r[14] =
            (m14 * m22 * m31 - m12 * m24 * m31 - m14 * m21 * m32 + m11 * m24 * m32 + m12 * m21 * m34 - m11 * m22 * m34) * d;
        r[15] =
            (m12 * m23 * m31 - m13 * m22 * m31 + m13 * m21 * m32 - m11 * m23 * m32 - m12 * m21 * m33 + m11 * m22 * m33) * d;
        return new Mat4(r);
    }
    applyToPoint(p) {
        const e = this.elements;
        const w = e[3] * p.x + e[7] * p.y + e[11] * p.z + e[15];
        return {
            x: (e[0] * p.x + e[4] * p.y + e[8] * p.z + e[12]) / w,
            y: (e[1] * p.x + e[5] * p.y + e[9] * p.z + e[13]) / w,
            z: (e[2] * p.x + e[6] * p.y + e[10] * p.z + e[14]) / w,
        };
    }
    applyToDirection(p) {
        const e = this.elements;
        return {
            x: e[0] * p.x + e[4] * p.y + e[8] * p.z,
            y: e[1] * p.x + e[5] * p.y + e[9] * p.z,
            z: e[2] * p.x + e[6] * p.y + e[10] * p.z,
        };
    }
}

function jointPointToMatrix(jp) {
    const r = Mat4.makeRotationZ(jp.rotation.z)
        .multiply(Mat4.makeRotationY(jp.rotation.y))
        .multiply(Mat4.makeRotationX(jp.rotation.x));
    const t = Mat4.makeTranslation(jp.position);
    return t.multiply(r);
}
function calculateJointTransform(parentJp, childJp) {
    return jointPointToMatrix(parentJp).multiply(jointPointToMatrix(childJp).invert());
}

function resolvePartLayout(parts) {
    const byKey = new Map();
    for (const p of parts) {
        if (byKey.has(p.partKey)) {
            throw new Error(`resolvePartLayout: duplicate partKey "${p.partKey}"`);
        }
        byKey.set(p.partKey, p);
    }
    const result = new Map();
    const visiting = new Set();
    function resolveOne(partKey) {
        const cached = result.get(partKey);
        if (cached)
            return cached;
        if (visiting.has(partKey)) {
            throw new LayoutResolverCycleError(partKey, [...visiting, partKey]);
        }
        const part = byKey.get(partKey);
        if (!part) {
            throw new LayoutResolverOrphanError(partKey);
        }
        visiting.add(partKey);
        let mat;
        if (part.layout.type === 'root') {
            mat = part.layout.transform;
        }
        else {
            const parentMat = resolveOne(part.layout.parentPartKey);
            const jointMat = calculateJointTransform(part.layout.parentJoint, part.layout.ownJoint);
            mat = parentMat.multiply(jointMat);
        }
        visiting.delete(partKey);
        result.set(partKey, mat);
        return mat;
    }
    for (const p of parts) {
        if (!result.has(p.partKey)) {
            resolveOne(p.partKey);
        }
    }
    return result;
}
class LayoutResolverCycleError extends Error {
    constructor(partKey, chain) {
        super(`resolvePartLayout: cycle detected at part "${partKey}" via [${chain.join(' → ')}]`);
        this.partKey = partKey;
        this.chain = chain;
        this.name = 'LayoutResolverCycleError';
    }
}
class LayoutResolverOrphanError extends Error {
    constructor(partKey) {
        super(`resolvePartLayout: part "${partKey}" referenced as parent but not found in input`);
        this.partKey = partKey;
        this.name = 'LayoutResolverOrphanError';
    }
}

export { AttributeBehaviourTypes, AttributeTypes, BomCalculator, BomList, BomRule, BomRuleError, CUSTOM_ATTRIBUTE_VALUE, ConfiguratorPV, IMAGE_FORMATS, LayoutResolverCycleError, LayoutResolverOrphanError, MAX_FILE_SIZE_BYTES, MAX_IMAGE_FILE_SIZE_BYTES, MAX_MODEL_FILE_SIZE_BYTES, MAX_PDF_LOGO_SIZE, MEGABYTE, Mat4, MaterialMaps, MaterialTypes, NA, NA_ATTRIBUTE_VALUE, PRICE_TYPE_SEPARATOR, PartsRegistry, RAL, SCENE_NESTING, StandardAttributes, SystemVariantTypes, VariantProperties, Versioning, addPrice, addVec, attributeValueCase, axisVec, boundaryToAABB, calculateJointTransform, canMovePart, canNestSceneNode, catalogMetaSchema, centerAABB, compareAttributeValue, compositeLogicOrderSchema, computePartsAmount, containsAABB, createAttributeValue, createCustomAttributeValue, createNodes, defaultChildPartLayout, defaultJP, defaultPosition, defaultRootPartLayout, defaultRotation, defaultTransform, emptyAABB, equals, evaluateBinding, extractAttributeValue, extractPropertyValue, findNextKeyPostfix, findPartNodes, fromCents, generateKey, getAllAcceptedSlotItems, getAttributeValue, getCurrencies, getCurrencyValue, getHqrDefaultImage, getImageFormat, getImageFormatDefinition, getRuleValidParentParts, getSlotSpace, getUniqueName, getValidParentParts, hasAttributeValue, hasHqrDefaultImage, iComponentBasicDataSchema, iComponentDataSchema, iComponentProductDataSchema, iComponentProductKeySchema, iComponentProductOptionsSchema, iComponentProductSchema, iComponentProductTextDataSchema, iComponentProductTextSchema, iComponentProductVariantKeySchema, iComponentProductVariantSchema, iComponentSchema, iComponentTextDataSchema, iComponentVariantKeySchema, iComponentVariantListSchema, iComponentVariantSchema, iCompositeLogicOrderItemSchema, iCompositeProductDataSchema, iCompositeProductFullDataSchema, iCompositeProductOmitRulesSchema, iCompositeProductProductTypeSchema, iCompositeProductSchema, iCompositeProductTextDataSchema, iCompositeProductTypeSchema, iCompositeProductVariantWithRulesSchema, iCompositeVariantKeySchema, iCompositeVariantSchema, iCompositeVariantsSchema, iPriceSchema, iPriceTypeInfoSchema, iProductComponentSchema, iProductKeySchema, iProductLogicOrderItemSchema, iProductSchema, iProductVariantAttributesSchema, iProductVariantMetaSchema, iProductVariantSchema, iSerializedComponentsSchema, iSerializedCompositeSchema, iSerializedCustomAttributeValueSchema, iSerializedPlacedItemSchema, iSerializedPlacedProductSchema, isAncestorOf, isBagPlacement, isCfgProductVariant, isConditionActive, isConditionalAcceptedItems, isEmpty, isICompositeVariant, isISystemAttributeValue, isKeyValid, isMaterialMap, isMaterialType, isNullishAttributeValue, isSkippingMetaId, isSystemAttribute, isSystemAttributeKey, isValidRAL, jointPointToMatrix, mulPriceByScalar, negatePrice, parsePriceKey, partToSceneNode, priceKey, priceTypeOrdinals, productLogicOrderSchema, projectPrice, ralCodeToHex, ralToHex, resolveAcceptedSlotItems, resolveBoundary, resolveOrigin, resolvePartLayout, resolvePartOrigin, resolveSpaceOrigin, scaleVec, sceneNodeId, sizeAlong, slotToSceneNode, subPrice, subVec, sumPrices, toCents, transformAABB, transformAABBByMat4, translateAABB, traverseForest, traverseTree, unionAABB, withSlotSpace, zeroPrice };
//# sourceMappingURL=bundle.mjs.map
